<script setup lang="ts">
import { computed } from 'vue'
import { $t } from '@previo/core'
import iconSet from 'quasar/icon-set/fontawesome-v6'
import { usePrevioDS } from '../../composables/helpers/index'
import { type PDataTablePaginationType } from './types'
import { usePagination } from './composables/usePagination'
import DataTablePaginationMobile from './components/DataTablePaginationMobile.vue'
import DataTablePaginationLaptop from './components/DataTablePaginationLaptop.vue'

iconSet.arrow.dropdown = 'fa fa-light fa-chevron-down'

const ds = usePrevioDS()

const pagination = defineModel<PDataTablePaginationType>({
  default: {
    rowsPerPage: 0,
  },
})

type Props = {
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  disabled: false,
})

const {
  startIndex,
  endIndex,
  isFirstPage,
  isLastPage,
  goToFirstPage,
  goToPrevPage,
  goToNextPage,
  goToLastPage,
} = usePagination(pagination)

const paginationText = computed<string>(() => {
  return $t('{startRowIndex} - {endRowIndex} of {totalRows}', {
    startRowIndex: startIndex.value,
    endRowIndex: endIndex.value,
    totalRows: pagination.value.rowsNumber,
  })
})
</script>

<template>
  <data-table-pagination-mobile
    v-if="ds.screen().isMobile"
    :is-first-page="isFirstPage"
    :is-last-page="isLastPage"
    :status-text="paginationText"
    :disabled="disabled"
    @prev="goToPrevPage"
    @next="goToNextPage"
  />

  <data-table-pagination-laptop
    v-else
    v-model:rows-per-page="pagination.rowsPerPage"
    :is-first-page="isFirstPage"
    :is-last-page="isLastPage"
    :status-text="paginationText"
    :disabled="disabled"
    @start="goToFirstPage"
    @prev="goToPrevPage"
    @next="goToNextPage"
    @end="goToLastPage"
  />
</template>
